import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Pagination from "../components/Pagination";
// import Switch from "../../components/Switch"; 

const DeviceList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [hasMore, setHasMore] = useState(true);
    const [totalItems, setTotalItems] = useState(0);

    const navigate = useNavigate();

    const token = getCookie("token");
    const userid = getCookie("userid");

    const fetchDeviceData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                'https://api.dqr-display-tms.eventum.co.in/api/DeviceInfoOperation/Search',
                {
                    pagesize: pageSize,
                    currentpageno: pageNo,
                    withoutpagination: false,
                    pagedirection: "string"
                },
                {
                    headers: {
                        "accept": "text/plain",
                        "X-Authorization": token,
                        "UserId": userid,
                        "Content-Type": "application/json-patch+json",
                    },
                }
            );

            if (response.data && Array.isArray(response.data.data)) {
                setData(response.data.data);
                setHasMore(response.data.data.length === pageSize);
            } else {
                setData([]);
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching device data:", error);
            setMessage("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDeviceData();
    }, [token, userid, pageNo, pageSize]);

    // Clean up message after display
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    // Pagination navigation functions
    const goFirst = () => {
        if (pageNo !== 0) setPageNo(0);
    };
    
    const goPrev = () => {
        if (pageNo > 0) setPageNo(pageNo - 1);
    };
    
    const goNext = () => {
        if (hasMore) setPageNo(pageNo + 1);
    };

    // New pagination handlers for Pagination component
    const handlePageChange = (page) => {
        setPageNo(page - 1); // Convert 1-based to 0-based
    };

    const handleItemsPerPageChange = (newItemsPerPage) => {
        setPageSize(newItemsPerPage);
        setPageNo(0); // Reset to first page
    };

    const totalPages = hasMore ? pageNo + 2 : pageNo + 1;

    return (
        <>
            <Menu />
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h1 className="mb-0">Device List</h1>
                                <button type="button" className="btn btn-success" onClick={fetchDeviceData}>
                                    Refresh
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <hr />
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        {/* Optional: Add search/filter inputs here if needed */}
                                        <div className="card-body table-responsive p-0">
                                            <table className="table table-hover table-striped">
                                                 <thead className="" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
                                                    <tr>
                                                        <th className="text-center">Id</th>
                                                        <th>Serial No</th>
                                                        <th>POS Name</th>
                                                        {/* <th>Device Type</th> */}
                                                        <th>Model No</th>
                                                        {/* <th>Hardware</th> */}
                                                        <th>Application Version</th>
                                                        <th className="text-center">Active</th>
                                                        <th>Activation Date</th>
                                                        <th>Updated Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan="10" className="text-center p-3">Loading...</td>
                                                        </tr>
                                                    ) : data.length > 0 ? (
                                                        data.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="text-center">{item.id}</td>
                                                                <td>{item.serialno}</td>
                                                                <td><strong>{item.posname || "-"}</strong></td>
                                                                {/* <td>{item.devicetype}</td> */}
                                                                <td>{item.devicemodelno}</td>
                                                                {/* <td>{item.devicehardware}</td> */}
                                                                <td>{item.devicesoftwareversion}</td>
                                                                <td className="text-center">
                                                                    {item.deviceactive ? (
                                                                        <span className="badge badge-success">Yes</span>
                                                                    ) : (
                                                                        <span className="badge badge-danger">No</span>
                                                                    )}
                                                                </td>
                                                                <td>{item.createddate ? new Date(item.createddate).toLocaleString() : "-"}</td>
                                                                <td>{item.lastmodifieddate ? new Date(item.lastmodifieddate).toLocaleString() : "-"}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="10" className="text-center">No data found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                        {/* Pagination */}
                                        <Pagination
                                            currentPage={pageNo + 1}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                            itemsPerPage={pageSize}
                                            onItemsPerPageChange={handleItemsPerPageChange}
                                            totalItems={data.length + (hasMore ? pageSize : 0)}
                                            showPageNumbers={false}
                                            showItemsPerPageSelector={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {message && (
                <div style={{ position: "fixed", top: "20px", right: "10px", width: "25%", zIndex: "9999" }}>
                    <div
                        className={`alert alert-danger d-flex align-items-center`}
                        role="alert"
                        style={{ marginBottom: "10px" }}
                    >
                        <div>{message}</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DeviceList;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}
